import React, { Component } from "react";
import { Loader } from "semantic-ui-react";
import Strings from "../utilities/StringSelector";

class UpdateLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderText: "",
    };
  }

  changeLoaderText = (newText) => {
    this.setState({ loaderText: newText });
  }

  render() {
    return (
      <Loader size="huge" indeterminate>
        {Strings.DO_NOT_CLOSE_THIS_TAB}<br />
        {this.state.loaderText}
      </Loader>
    );
  }
}

export default UpdateLoader;
